import { useParams } from 'react-router-dom'
import { AdminShell } from '../components/admin/AdminShell'
import { AdminPageHeader } from '../components/admin/AdminAtoms'
import { OccurrenceManagement } from '../components/management/OccurrenceManagement'
import { useChurch } from '../hooks/useChurches'
import { useSubscriptionStatus } from '../hooks/useChurchAdmin'

export default function HostManagementPage() {
  const { slug, occurrenceId } = useParams<{ slug: string; occurrenceId: string }>()
  const { data: churchData } = useChurch(slug)
  const church = churchData?.data
  const { data: subData } = useSubscriptionStatus(church?.id)
  const tier = subData?.data.tier

  // Default unlocked until subscription loads — avoids a flash of locked state
  const canBroadcast = !tier || tier === 'community' || tier === 'connection'

  return (
    <AdminShell>
      <AdminPageHeader
        breadcrumb={['Dashboard', 'Guest list']}
        title="Guest list."
      />
      {occurrenceId && (
        <OccurrenceManagement
          occurrenceId={occurrenceId}
          canBroadcast={canBroadcast}
          upgradeUrl={slug ? `/churches/${slug}/billing` : undefined}
        />
      )}
    </AdminShell>
  )
}
